<script setup>
import { reactiveOmit } from '@vueuse/core';
import { RangeCalendarHeading, useForwardProps } from 'reka-ui';
import { cn } from '@/lib/utils';

const props = defineProps({
    asChild: { type: Boolean, required: false },
    as: { type: null, required: false },
    class: { type: null, required: false },
});

defineSlots();

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
    <RangeCalendarHeading v-slot="{ headingValue }" :class="cn('text-sm font-medium', props.class)" v-bind="forwardedProps">
        <slot :heading-value>
            {{ headingValue }}
        </slot>
    </RangeCalendarHeading>
</template>
